import { createSelector } from 'reselect';

// Config
import { getStripeCheckoutFlowEnabledSelector } from '@components/streamlined-payments/pay-now-category/AddNewCard.state';
import { getSessionIdSelector } from '@redux/reducers/bff/bffSelector';
import { getGooglePayConfiguration } from '@redux/reducers/config/configSelector';
import { getGooglePayCardPaymentMethod, getGooglePayStubsModalOpen } from '@redux/reducers/payment/paymentSelector';

const googlePayButtonState = createSelector(
  [
    getGooglePayCardPaymentMethod,
    getGooglePayStubsModalOpen,
    getGooglePayConfiguration,
    getSessionIdSelector,
    getStripeCheckoutFlowEnabledSelector,
  ],
  (
    googlePayCardPaymentMethod,
    googlePayStubsModalOpen,
    googlePayConfiguration,
    sessionId,
    stripeCheckoutFlowEnabled,
  ) => ({
    cardPaymentMethod: googlePayCardPaymentMethod,
    googlePayStubsModalOpen,
    googlePayConfiguration,
    sessionId,
    stripeCheckoutFlowEnabled,
  }),
);

export default googlePayButtonState;
